module.exports = __webpack_public_path__ + "img/panelView_1_3.bfe39d7d.png";